import { Api } from "@/utils/Api";
import { env } from "@/config/env";
import qs from "qs";

import { AxiosInstance } from "axios";
import { UserStorage } from "@/storage/UserStorage";
import { captureApiError } from "./sentry";

const setupInterceptors = (client: AxiosInstance) => {
	client.defaults.paramsSerializer = params => qs.stringify(params, { arrayFormat: "repeat" });

	client.interceptors.request.use(config => {
		const token = UserStorage.getToken();
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	});

	client.interceptors.response.use(
		response => response,
		error => {
			if (error?.response?.status === 500) {
				captureApiError("Backoffice api", error);
			}

			const isLoginRequest = error?.config?.url === "/Account/Login";
			if (error?.response?.status === 401 && !isLoginRequest) {
				UserStorage.removeToken();
				window.location.href = "/login";
			}
			return Promise.reject(error);
		},
	);
};

export const backofficeApi = new Api(`${env.DRYP_API_URL}api/backoffice` || "", {}, setupInterceptors);
